import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MedicosService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${environment.apiUrl}/user/get_users`).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  create(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/user/signup`, data).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  deleteAccount(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/user/delete_user`, data).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  update(data: any) {
    return this.http
      .put<any>(`${environment.apiUrl}/user/update`, {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        email_2: data.email_2,
        phone_number: data.phone_number,
        phone_number_2: data.phone_number_2,
        specialty_id: data.specialty_id,
        active: data.active
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload
          }
          return response
        })
      )
  }

  updateProfile(data: any) {
    return this.http.put<any>(`${environment.apiUrl}/user/update_profile`, data).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  getRols(country_id: any) {
    return this.http
      .post<any>(`${environment.apiUrl}/user/get_rol_by_country`, {
        id: country_id
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload
          }
          return response
        })
      )
  }

  confirmRegistration(token: string) {
    /* const encodedToken = encodeURIComponent(token); */
    return this.http.post<any>(`${environment.apiUrl}/user/confirm-registration`, { token }).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => ({ 
            payload: { message: 'Algo esta fallando en el servidor, por favor contacte a soporte' }
          }))
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => ({ 
            payload: { message: 'El acceso a esta solicitud no esta permitido' }
          }))
        }
        return throwError(() => ({ 
          payload: { message: 'Ups algo salio mal, por favor contacte a soporte' }
        }))
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }
}
